import { render, staticRenderFns } from "./CreatCustomerParameter.vue?vue&type=template&id=f38c489e"
import script from "./CreatCustomerParameter.vue?vue&type=script&lang=js"
export * from "./CreatCustomerParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports